// extracted by mini-css-extract-plugin
export default {"shalina-radioGroup":"radio_shalina-radioGroup__oY33f","mainLabel":"radio_mainLabel__ktgBB"};